import React, {useState, useEffect, useRef} from 'react';
import DatePicker from "react-datepicker";
import {findAllPdvProductsByQueryString, findPdvSalesByStatus} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import 'react-datepicker/dist/react-datepicker.css';

const PdvSalesListItems = () => {
    const [productQuantityList, setProductQuantityList] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [queryString, setQueryString] = useState('');
    const [, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery() {
        try {
            setLoading(true);
            const newStartDate = startDate || new Date(1900, 0, 1);
            const newEndDate = endDate || new Date(2100, 0, 1);
            const sales = await findPdvSalesByStatus(newStartDate, newEndDate, -1) || [];

            const grouped = {};
            sales.forEach(sale => {
                (sale.saleItems || []).forEach(item => {
                    if (!grouped[item.product.id]) grouped[item.product.id] = 0;
                    grouped[item.product.id] += item.quantity;
                });
            });

            const products = await findAllPdvProductsByQueryString('') || [];
            let list = Object.keys(grouped).map(productId => {
                const product = products.find(p => String(p.id) === String(productId));
                return {
                    productName: product ? product.name : `Produto #${productId}`,
                    quantity: grouped[productId]
                };
            });

            if (queryString?.trim()) {
                list = list.filter(p => p.productName?.toUpperCase().includes(queryString.trim()));
            }

            list = list.sort((a, b) => b.quantity - a.quantity);
            setProductQuantityList(list);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { makeQuery(); }, []);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    const handleInputChange = (e) => {
        setQueryString(removeSpecialChars(e.target.value).toUpperCase());
    };

    return (
        <>
            <div className="header-label">Itens Vendidos</div>
            <div style={{marginTop: '5px'}}>
                <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                    <DatePicker className="datepicker" selected={startDate} onChange={setStartDate}
                        isClearable dateFormat="dd/MM/yyyy"/>
                    até
                    <DatePicker className="datepicker" selected={endDate} onChange={setEndDate}
                        dateFormat="dd/MM/yyyy" isClearable/>
                </div>
                <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                    <input style={{width: '100%'}} type="text" value={queryString} onChange={handleInputChange}/>
                    <button onClick={makeQuery}>Consultar</button>
                </div>
            </div>
            <div style={{flexGrow: 1, overflowY: 'auto'}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '120px'}}/>
                        <col style={{width: '400px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>Quantidade</th>
                        <th>Produto</th>
                    </tr>
                    </thead>
                    <tbody>
                    {productQuantityList.map((pq, index) => (
                        <tr key={index} style={{height: '41px'}}>
                            <td><div>{pq.quantity}</div></td>
                            <td><div>{pq.productName}</div></td>
                        </tr>
                    ))}
                    </tbody>
                    {productQuantityList.length === 0 && <tfoot><tr><td colSpan={2}>Nenhum item encontrado</td></tr></tfoot>}
                </table>
            </div>
        </>
    );
};

export default PdvSalesListItems;
